import { z } from 'zod'

export const vehicleSchema = z
  .object({
    plate: z
      .string()
      .min(1, 'Placa obrigatória')
      .transform((v) => v.toUpperCase().replace(/[-\s]/g, ''))
      .refine((v) => /^[A-Z]{3}(\d{4}|\d[A-Z]\d{2})$/.test(v), {
        message: 'Placa inválida. Use ABC-1234 ou ABC1D23 (Mercosul)',
      }),
    renavam: z.string().max(11).optional(),
    brand: z.string().max(50).optional(),
    model: z.string().max(50).optional(),
    year: z.coerce
      .number()
      .int()
      .min(1900)
      .max(2099)
      .optional()
      .or(z.literal('' as unknown as number)),
    vehicleType: z.enum(['FIORINO', 'VAN', 'VUC', 'TOCO', 'TRUCK', 'BITRUCK', 'CARRETA', 'RODOTREM'], {
      error: 'Tipo de veículo obrigatório',
    }),
    ownership: z.enum(['COMPANY', 'DRIVER'], {
      error: 'Proprietário obrigatório',
    }),
    ownerId: z.string().optional().or(z.literal('')),
    capacityKg: z.coerce
      .number()
      .positive()
      .optional()
      .or(z.literal('' as unknown as number)),
    bodyLength: z.coerce
      .number()
      .positive()
      .optional()
      .or(z.literal('' as unknown as number)),
    bodyWidth: z.coerce
      .number()
      .positive()
      .optional()
      .or(z.literal('' as unknown as number)),
    bodyHeight: z.coerce
      .number()
      .positive()
      .optional()
      .or(z.literal('' as unknown as number)),
    rntrc: z.string().max(20).optional(),
    crlvNumber: z.string().max(20).optional(),
    crlvExpiry: z.string().optional(),
    insuranceCompany: z.string().max(100).optional(),
    insurancePolicy: z.string().max(50).optional(),
    insuranceExpiry: z.string().optional(),
  })
  .refine((d) => d.ownership !== 'DRIVER' || !!d.ownerId, {
    message: 'Motorista proprietário obrigatório',
    path: ['ownerId'],
  })

export type VehicleFormData = z.infer<typeof vehicleSchema>
